/**
 * Unlike most modals, this isn't marked as modal component in its file name, but it is a modal component.
 */

import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UserService } from '../../core/services/data/user.service';

@Component({
	selector: 'app-tabs-account-menu',
	templateUrl: './tabs-account-menu.component.html',
	styleUrls: ['./tabs-account-menu.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})

export class TabsAccountMenuComponent implements OnInit, OnDestroy {
	public author;

	public author$;

	constructor(
		private uss: UserService,
	) {
	}

	get authorInfoLink(): string {
		return `/author-dashboard/${this.author?.authorLink}/account`;
	}

	get authorProfileLink(): string {
		return `/author-dashboard/${this.author?.authorLink}/author-profile`;
	}

	get contactInfoLink(): string {
		return `/author-dashboard/${this.author?.authorLink}/account-contact-info`;
	}

	get changePasswordLink(): string {
		return `/author-dashboard/${this.author?.authorLink}/account-login-security`;
	}

	get billingLink(): string {
		return `/author-dashboard/${this.author?.authorLink}/billing`;
	}

	ngOnInit(): void {
		this.author$ = this.uss.author$.subscribe((author) => {
			this.author = author;
		});
	}

	ngOnDestroy(): void {
		this.author$.unsubscribe();
	}
}
